window.addEventListener("load", () => {
  const atcBtn = document.getElementById("add-bundle-to-cart");
  const mainPrice = atcBtn.querySelector(".main-product-price");
  const price = mainPrice.querySelector(".price");
  const discountedPrice = atcBtn.querySelector(".discountedPrice");
  discountedPrice.textContent = price.textContent;
  const mainPriceObserver = new MutationObserver(() => {
    if (!discountedPrice.textContent.trim()) {
      discountedPrice.textContent = price.textContent;
    }
  });
  mainPriceObserver.observe(mainPrice, { childList: true, subtree: true });
});